// extracted by mini-css-extract-plugin
module.exports = {"border":"Checkbox-moduleborder3zU","indicator":"Checkbox-moduleindicator18y","listIndicator":"Checkbox-modulelistIndicator28n"};